import Guard from '../../services/Middleware'

export default [
  {
    path: '/Cargas',
    name:'Cargas',
    component: () => import('@/views/cargas/MenuCargas.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Cargas/Piracanjuba',
    name:'Piracanjuba',
    component: () => import('@/views/cargas/IndexPiracanjuba.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Cargas/DHL',
    name:'DHL',
    component: () => import('@/views/cargas/IndexDhl.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Cargas/Geral/Adicionar',
    name:'Adicionar Carga',
    component: () => import('@/views/cargas/IndexAddCargas.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Cargas/Geral/Editar/:carga',
    name:'Editar Carga',
    component: () => import('@/views/cargas/editarCargas.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Cargas/Geral/Giro',
    name:'Giro Cargas',
    component: () => import('@/views/cargas/giro/IndexGiros.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Cargas/Geral',
    name:'Geral Cargas',
    component: () => import('@/views/cargas/IndexGeral.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Cargas/Geral/Giro/Adicionar-Selecao',
    name:'Selecao Giro Cargas',
    component: () => import('@/views/cargas/giro/SelectAddGiros.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Cargas/Geral/Giro/Adicionar-Selecao/Giro-por-CT-e',
    name:'Adicionar Giro CT-e',
    component: () => import('@/views/cargas/giro/addGiroPorCte.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Cargas/Geral/Giro/Adicionar-Selecao/Giro-por-Carga',
    name:'Adicionar Giro Cargas',
    component: () => import('@/views/cargas/giro/addGiroPorCargas.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Cargas/Geral/Giro/Giro-por-Carga/:id',
    name:'Editar Giro Cargas',
    component: () => import('@/views/cargas/giro/addGiroPorCargas.vue'),
    beforeEnter: Guard.auth
  },
  
]